import { IonIcon, IonModal } from "@ionic/react";
import { closeOutline, checkmarkCircleOutline } from "ionicons/icons";
import { useRef } from "react";
import { IonText } from "@ionic/react";
import "./examReadyModal.css";

interface IExamReadyModal {
  isOpen: boolean;
  moduleName: string;
  handleClose: () => void;
}

export const ExamReadyModal: React.FC<IExamReadyModal> = ({
  isOpen,
  moduleName,
  handleClose,
}) => {
  const modal = useRef<HTMLIonModalElement>(null);

  function dismiss() {
    handleClose();
    modal.current?.dismiss();
  }

  return (
    <IonModal id="modal-exam-ready" isOpen={isOpen} ref={modal}>
      <div className="wrapper-exam-ready">
        <div className="modal-header">
          <IonIcon
            onClick={dismiss}
            color="dark"
            style={{ width: 30, height: 30 }}
            slot="icon-only"
            icon={closeOutline}
          />
        </div>
        <div className="exam-ready-content">
          <div className="exam-ready-icon">
            <IonIcon
              icon={checkmarkCircleOutline}
              color="success"
              style={{ width: 64, height: 64 }}
            />
          </div>
          <IonText color="orange" className="exam-ready-title">
            ¡Listo para certificarte!
          </IonText>
          <IonText color="dark" className="exam-ready-message">
            Estás habilitado para rendir el examen de certificación del módulo{" "}
            <strong>{`"${moduleName}"`}</strong>.
          </IonText>
          <IonText color="medium" className="exam-ready-subtitle">
            Puedes acceder al examen desde el módulo cuando lo desees.
          </IonText>
        </div>
      </div>
    </IonModal>
  );
};
